import './RecordDetailsLayoutScreen.scss';
import {useCallback, useEffect, useState} from "react";
import {CommonService} from "../../../shared/services";
import {useNavigate, useParams} from "react-router-dom";
import ViewMedicalRecordScreen from "../view-medical-record/ViewMedicalRecordScreen";
import BackComponent from "../../../shared/components/back/BackComponent";
import LoaderComponent from "../../../shared/components/loader/LoaderComponent";
import ModalComponent from "../../../shared/components/modal/ModalComponent";
import ButtonComponent from "../../../shared/components/button/ButtonComponent";
import FacilityDetailsComponent from "../facility-details/FacilityDetailsComponent";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../store/reducers";

interface RecordDetailsLayoutScreenProps {

}

const RecordDetailsLayoutScreen = (props: RecordDetailsLayoutScreenProps) => {

    const {caseId} = useParams();
    const navigate = useNavigate();
    const [getMedicalRecordData, setMedicalRecordData] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [isContactUsModalOpen, setIsContactUsModalOpen] = useState<boolean>(false);
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);
    const [isRestrictModalOpen, setIsRestrictModalOpen] = useState<boolean>(false);

    const getMedicalRecordDetails = useCallback((id: string) => {
        setLoading(true)
        CommonService._cases.MedicalRecordViewDetails(id)
            .then((response: any) => {
                setMedicalRecordData(response?.data);
                setLoading(false)
            }).catch((error: any) => {
            setLoading(false)
            console.log(error)
            setMedicalRecordData(null)
        })
    }, [])

    useEffect(() => {
        if (caseId) {
            getMedicalRecordDetails(caseId)
        }
    }, [caseId, getMedicalRecordDetails]);

    const navigateToClientCases = useCallback(() => {
        navigate(CommonService._routeConfig.ClientCases());
    }, [navigate]);

    const handleBookAppointment = useCallback(() => {
        if (currentUser?.independent_appointment_booking === 'Restricted') {
            setIsRestrictModalOpen(true)
        } else {
            navigate(CommonService._routeConfig.BookAppointmentRoute())
        }
    }, [currentUser, navigate]);


    return (
        <div className="record-details-layout-screen">
            <div className="list-screen__header">
                <div className="list-screen__header-title">
                    <BackComponent onClick={navigateToClientCases}/>
                </div>
                <div className={'contact-appointment-wrapper'}>
                    <div className={'contact-number-wrapper'}>
                        <div className={'contact-message'}>For any questions or concerns, please <span
                            onClick={() => setIsContactUsModalOpen(true)}
                            className={'contact-us'}>contact us.</span></div>

                    </div>
                    {getMedicalRecordData?.status === 'open' &&
                        <ButtonComponent onClick={handleBookAppointment} className={'mrg-left-15'}>Book
                            Appointment</ButtonComponent>
                    }
                </div>

            </div>
            {
                loading && <LoaderComponent/>
            }
            {!loading && <ViewMedicalRecordScreen medicalRecordData={getMedicalRecordData}/>}

            <ModalComponent isOpen={isContactUsModalOpen}
                            closeOnBackDropClick={true}
                            modalFooter={<ButtonComponent color={'accent'} className={'mrg-bottom-30 mrg-top-10'}
                                                          onClick={() => setIsContactUsModalOpen(false)}>
                                Close
                            </ButtonComponent>}
                            onClose={() => setIsContactUsModalOpen(false)}>
                <FacilityDetailsComponent title={'Contact Us'}/>
            </ModalComponent>
            <ModalComponent isOpen={isRestrictModalOpen}
                            closeOnBackDropClick={true}
                            modalFooter={<ButtonComponent color={'accent'} className={'mrg-bottom-30 mrg-top-10'}
                                                          onClick={() => setIsRestrictModalOpen(false)}>
                                Close
                            </ButtonComponent>}
                            onClose={() => setIsRestrictModalOpen(false)}>
                <FacilityDetailsComponent
                    title={<>Online Booking Unavailable.<br/> Contact us to book an appointment.</>}/>
            </ModalComponent>
        </div>
    );
}
export default RecordDetailsLayoutScreen;
